import Vue from "vue";
import axios from "axios";
import commonService from "./common";
let reportURL = `${process.env.VUE_APP_CORDOVA_REPORTS_URL}`;

const reportsDashboardService = {
	getReportPeriod() {
		//get the last 12 months as period
		var monthName = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
		var periods = [];
		var d = new Date();
		d.setDate(d.getDate() - 30);
		for (var i = 0; i < 12; i++) {
			periods.push(monthName[d.getMonth()] + " " + d.getFullYear());
			d.setDate(d.getDate() - 30);
		}
		return new Promise(function (resolve, reject) {
			setTimeout(function () {
				resolve(periods);
			}, 10);
		});
	},

	getViewReport(report, period, sort, start) {
		//The max records for paging scan be set somewhere else and passed if needed
		let maxlength = 100;
		let randomSeed = Math.random() * 1234567890;
		let reportName = encodeURI(report);
		let param = `IOT_GetReport&report=${reportName}&sort=${sort}&start=${start}&period=${period}&length=${maxlength}&_=${randomSeed}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitExportReport(name, period, email) {
		let param = `IOT_ExportAndEmailReport&report=${name}&period=${period}&fileFormat=CSV&email=${email}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getCordovaReportData(param) {
		let url = `${reportURL}/report/json/?report=${param}&content_only=true`;
		return Vue.axios.get(url);
	},

	emailReport(param) {
		let url = `${reportURL}/email?${param}`;
		return Vue.axios.get(url);
	},
};

export default reportsDashboardService;
